import { API_ENDPOINTS, POLLING_CONFIG } from '../config';

/**
 * Submit a new belief kernel
 */
export async function submitKernel(data) {
  const response = await fetch(API_ENDPOINTS.submitKernel, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to submit kernel');
  }

  return response.json();
}

/**
 * Get kernel by ID
 */
export async function getKernel(kernelId) {
  const response = await fetch(API_ENDPOINTS.getKernel(kernelId));

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch kernel');
  }

  return response.json();
}

/**
 * Trigger private intake agent processing
 */
export async function triggerIntakeAgent(kernelId) {
  const response = await fetch(API_ENDPOINTS.triggerIntakeAgent(kernelId), {
    method: 'POST',
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to trigger intake agent');
  }

  return response.json();
}

/**
 * Poll kernel status until processing is complete
 */
export async function pollKernelStatus(kernelId, onUpdate = null) {
  let attempts = 0;
  const maxAttempts = POLLING_CONFIG.maxAttempts;

  while (attempts < maxAttempts) {
    const response = await getKernel(kernelId);
    const kernel = response.kernel;

    if (onUpdate) {
      onUpdate(kernel);
    }

    // Check if processing is complete
    if (kernel.status === 'public_complete' || kernel.status === 'error') {
      return kernel;
    }

    // Wait before polling again
    await new Promise(resolve => setTimeout(resolve, POLLING_CONFIG.interval));
    attempts++;
  }

  throw new Error('Polling timeout: Processing took too long');
}

// Note: PDF text extraction is now done client-side using pdfjs-dist
// See utils/pdfExtractor.js
